
import { defineComponent, onUnmounted } from "vue";

const props = {
  active: {
    type: Boolean,
    required: true,
    default: false
  }
};

function changeFilter(value: string) {
  const app = document.getElementById("app");
  if (app) {
    app.style.filter = value;
  } else {
    throw new Error("#app doesn't exist.");
  }
}

function setup() {
  changeFilter("blur(4px);");

  onUnmounted(() => {
    changeFilter("");
  });
}

const Dialog = defineComponent({
  name: "Dialog",
  props,
  setup
});

export default Dialog;
